import React, { useEffect, useRef, useState } from "react";
import { Info } from "lucide-react";

// A small info icon that reveals an explanation on click — for the "how does
// this actually work" question that keeps coming up on both onboarding pages.
// Click-to-toggle rather than hover, so it works the same on touch and desktop
// and doesn't disappear while you're reading it.
export default function InfoTooltip({ children, width = 340, title = "How this page works" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div ref={ref} style={{ position: "relative", display: "inline-flex" }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        title={title}
        aria-label={title}
        aria-expanded={open}
        style={{
          display: "inline-flex", alignItems: "center", justifyContent: "center",
          width: 26, height: 26, borderRadius: "50%", border: "1px solid var(--c-200)",
          background: open ? "var(--blue-50, rgba(80,120,255,.12))" : "var(--surface)",
          color: "var(--blue-600)", cursor: "pointer", padding: 0,
        }}
      >
        <Info size={15} />
      </button>
      {open && (
        <div
          style={{
            position: "absolute", top: "calc(100% + 8px)", right: 0, width,
            background: "var(--surface)", border: "1px solid var(--c-200)", borderRadius: 12,
            boxShadow: "0 8px 24px rgba(0,0,0,.15)", padding: "14px 16px", zIndex: 50,
            fontSize: 12.5, lineHeight: 1.7, color: "var(--c-700)",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
}
